import angular from 'angular';
import creditHistoryTable from './creditHistoryTable';

export default angular
  .module('creditHistoryImproved.components', [])
  .component('creditHistoryTable', creditHistoryTable).name;
